__webpack_require__.p = "/web-plp-scaffold-ui/_next/";